/*
 * $Id:: App.js 2021/03/02 03:04 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { globals as globalsSlice } from './app/globalsSlice';
import { error as giLiteralsError, literals as literalsData } from './app/literalsSlice';
import AlertExpiringMessages from './components/AlertExpiringMessages';
import Footer from './components/Footer';
import FooterMobile from './components/Footer/FooterMobile';
import Header from './components/Header/Header';
import Notification from './components/Notification';
import Sidebar from './components/Sidebar';
import { RenderRoutes, routes, userAreaTheme } from './config';
import { ThemeProvider } from './providers';

const useStyles = makeStyles((_theme) => ({
    content: {
        boxShadow: '0px 1px 4px 1px #c4c4d2',
        marginTop: '84px',
        minHeight: 'calc(100vh - 325px - 85px)', // 100vh - footerHeight - headerHeight
        backgroundColor: '#FBFBFB',
        paddingBottom: '35px',
        '@media (max-width:960px)': {
            minHeight: 'calc(100vh - 490px - 85px)',
        },
    },
    loading: {
        margin: '0 auto',
        textAlign: 'center',
        height: '100vh',
    },
    globalLoading: {
        margin: '0 auto',
        top: '40%',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    mainPage: {
        display: 'flex',
        flexFlow: 'row nowrap',
        backgroundColor: '#FBFBFB',
        padding: '35px 0',
        marginBottom: '96px',
        height: '100%',
        '@media (max-width:960px)': {
            padding: '35px 20px',
        },
    },
    sidebarContainer: {
        padding: '0px 20px',
        backgroundColor: '#FBFBFB',
        width: '238px',
        '@media (max-width:960px)': {
            visibility: 'hidden',
            width: '0',
            minWidth: '0',
            padding: '0',
        },
    },
}));

function App() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const literals = useSelector(literalsData);
    const literalsError = useSelector(giLiteralsError);
    const globals = useSelector(globalsSlice);
    const isTablet = useMediaQuery('(max-width:960px)');

    const { globalLoading } = globals;
    useEffect(() => {
        dispatch({ type: 'globals/fetchGlobals', payload: null });
    }, [dispatch]);

    let render = '';
    const template = (
        <ThemeProvider theme={userAreaTheme}>
            <Router basename={process.env.REACT_APP_BASENAME}>
                <Grid container>
                    <Grid item xs={12}>
                        <Header smallDevice={isTablet} />
                    </Grid>
                    <Grid item xs={12} color="secondary" className={classes.content}>
                        <div className={classes.mainPage}>
                            <Box width={238} className={classes.sidebarContainer}>
                                <Sidebar />
                            </Box>
                            <RenderRoutes routes={routes} />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        {isTablet ? <FooterMobile /> : <Footer />}
                    </Grid>
                </Grid>
                <Notification />
                <AlertExpiringMessages />
            </Router>
        </ThemeProvider>
    );

    if (!literals || globalLoading || literalsError) {
        render = (
            <div className={classes.loading}>
                <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
                    <CircularProgress />
                </Box>
            </div>
        );
    } else {
        render = template;
    }

    return <>{render}</>;
}

export default App;
